import axios from 'axios';
import apiConfig from '../../api.config';

export default function getPoliceS3UserConfig({ hotelId }) {
  const {
    host,
    URIs: { policeReportS3userConfig },
  } = apiConfig;

  const uri = `${host}${policeReportS3userConfig}`.replace(':hotelId', hotelId);

  return axios.get(uri).then(res => {
    return res.data;
  });
}
